import React from 'react';

function Home({ navigateTo, openModal, onSelectService }) {
  return (
    <div className="page-home">
      {/* HERO SECTION */}
      <section id="hero" className="hero-section">
        <div className="badge-transform">Your Digital Growth Partner</div>
        <h1 className="hero-title">
          <span>Grow Your Business in the</span>
          <span className="highlight">Digital World</span>
        </h1>
        <p className="hero-desc">
          Saveera Biotech helps businesses strengthen their digital presence through digital marketing, 
          IT consultancy and technology-driven solutions.
        </p>
        
        <div className="hero-buttons">
          <button className="btn-primary" onClick={() => navigateTo('services')}>Explore Our Services</button>
          <button className="btn-secondary" onClick={() => navigateTo('contact')}>Get in Touch</button>
        </div>

        <ul className="hero-bullets-container">
          <li className="bullet-item">
            <span className="bullet-dot"></span> Digital Marketing
          </li>
          <li className="bullet-item">
            <span className="bullet-dot"></span> IT Consultancy
          </li>
          <li className="bullet-item">
            <span className="bullet-dot"></span> Custom Software
          </li>
        </ul>
      </section>

      {/* PARTNER DETAIL SECTION */}
      <section className="section bg-alt-dark">
        <div className="section-header">
          <span className="section-tag">About Our Strategy</span>
          <h2 className="section-title">Your Digital Growth Partner</h2>
          <p className="section-subtitle" style={{ maxWidth: '800px', fontSize: '1.2rem', lineHeight: '1.8' }}>
            Businesses today need more than just technology—they need the right digital strategy. At Saveera Biotech, 
            we combine digital marketing expertise with IT consultancy to help businesses improve their online visibility, 
            connect with customers and adopt practical technology solutions.
          </p>
        </div>
      </section>

      {/* WHAT WE DO SECTION */}
      <section className="section">
        <div className="section-header">
          <span className="section-tag">Core Offerings</span>
          <h2 className="section-title">What We Do</h2>
          <p className="section-subtitle">A high-level overview of our primary focus areas designed to drive business success.</p>
        </div>

        <div className="features-grid">
          <div className="feature-card" onClick={() => onSelectService('Digital Marketing')}>
            <div className="feature-icon-wrapper">📈</div>
            <h3 className="feature-title">Digital Marketing</h3>
            <p className="feature-desc">Build your online presence through SEO, social media, content, digital advertising and strategic marketing.</p>
          </div>
          <div className="feature-card" onClick={() => onSelectService('IT Consultancy')}>
            <div className="feature-icon-wrapper">🧑‍💻</div>
            <h3 className="feature-title">IT Consultancy</h3>
            <p className="feature-desc">Get practical technology guidance to improve your business processes, systems and digital capabilities.</p>
          </div>
          <div className="feature-card" onClick={() => onSelectService('Web & Digital Solutions')}>
            <div className="feature-icon-wrapper">🌐</div>
            <h3 className="feature-title">Web & Digital Solutions</h3>
            <p className="feature-desc">Develop modern digital solutions that help businesses establish and grow their online presence.</p>
          </div>
          <div className="feature-card" onClick={() => onSelectService('Computer & IT Services')}>
            <div className="feature-icon-wrapper">💻</div>
            <h3 className="feature-title">Technology Services</h3>
            <p className="feature-desc">Computer programming, technology consulting and other IT-related services tailored to business requirements.</p>
          </div>
        </div>
      </section>

      {/* CTA INTERMEDIARY BLOCK */}
      <section className="section bg-gradient-cta" style={{ textAlign: 'center', padding: '5rem 5%' }}>
        <h2 className="section-title" style={{ marginBottom: '1.5rem' }}>Let's Build Your Digital Future</h2>
        <p className="section-subtitle" style={{ margin: '0 auto 2.5rem auto', maxWidth: '650px' }}>
          Whether you are starting a new business or looking to improve your existing digital presence, 
          Saveera Biotech can help you identify the right technology and marketing approach.
        </p>
        <button className="btn-primary" onClick={() => openModal('consultation')}>Request Consultation</button>
      </section>
    </div>
  );
}

export default Home;
